export enum CsvErrorCategory {
  SORT = 'sort',
  FILTER = 'filter',
  LAYOUT = 'layout',
  FIELD = 'field',
  VIEW = 'view',
  VALUE = 'value',
  ENTRY = 'entry',
  METADATA = 'metadata',
  PARSING = 'parsing',
}

export enum CsvErrorType {
  PARSING = 'parsing',
  VALIDATION = 'validation',
}

export interface CsvError {
  message: string;
  category: CsvErrorCategory;
  type: CsvErrorType;
  timestamp: number;
  context?: string;
}

export class CsvErrorCollector {
  private errors: CsvError[] = [];

  addError(
    message: string,
    category: CsvErrorCategory,
    type: CsvErrorType,
    context?: string
  ): void {
    this.errors.push({
      message,
      category,
      type,
      timestamp: Date.now(),
      context,
    });
  }

  getErrors(): CsvError[] {
    return [...this.errors];
  }

  clearErrors(): void {
    this.errors = [];
  }

  hasErrors(): boolean {
    return this.errors.length > 0;
  }

  getErrorCount(): number {
    return this.errors.length;
  }

  getErrorsByCategory(category: CsvErrorCategory): CsvError[] {
    return this.errors.filter((error) => error.category === category);
  }

  getErrorsByType(type: CsvErrorType): CsvError[] {
    return this.errors.filter((error) => error.type === type);
  }
}
